// --- ModelsAuxiliary.tsx ---
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import BriaButtonGroup from "../../../components/common/BriaButtonGroup/BriaButtonGroup";
import LinkConstants from "../../../constants/LinkConstants";

import AuxiliaryCanny from "../../../assets/Models/images/auxiliary-2_3_canny.png";
import AuxiliaryColorGrid from "../../../assets/Models/images/auxiliary-2_3_colorgrid.png";
import AuxiliaryDepth from "../../../assets/Models/images/auxiliary-2_3_depth.png";
import AuxiliaryFastLora from "../../../assets/Models/images/auxiliary-2_3_fast_lora.png";
import AuxiliaryImagePrompt from "../../../assets/Models/images/auxiliary-2_3_image_prompt.png";
import AuxiliaryInpainting from "../../../assets/Models/images/auxiliary-2_3_inpainting.png";
import AuxiliaryIDPreservation from "../../../assets/Models/images/auxiliary-2_3_ip_adapt.png";
import AuxiliaryPose from "../../../assets/Models/images/auxiliary-2_3_pose.png";
import AuxiliaryRecoloring from "../../../assets/Models/images/auxiliary-2_3_recolor.png";
import Auxiliary4BAdaptUnion from "../../../assets/Models/images/auxiliary-4b_adapt_union.png";
import AuxiliaryGenFill from "../../../assets/Models/images/auxiliary-genfill.png";
import AuxiliaryIncreaseRes from "../../../assets/Models/images/auxiliary-increase_res.png";
import AuxiliaryRMBG from "../../../assets/Models/images/auxiliary-remove_bg.png";
import AuxiliaryBGGen from "../../../assets/Models/images/auxiliary-replace_bg.png";
import HuggingFace from "../../../assets/images/icons/HuggingFace";

const ModelsAuxiliary = () => {
	const { t } = useTranslation("translation", { keyPrefix: "models.auxiliary" });
	const openDocs = (link: string) => window.open(link, "_blank");

	const cards: ConsoleAPICardProps[] = [
		{
			image: Auxiliary4BAdaptUnion,
			header: t("cards.bria3_2_union.header"),
			description: t("cards.bria3_2_union.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["BRIA3_2_UNION"].HUGGING_FACE.MODEL)}
					>
						{t("cards.bria3_2_union.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["BRIA3_2_UNION"].HUGGING_FACE.DEMO)}
					>
						{t("cards.bria3_2_union.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: Auxiliary4BAdaptUnion, // Using Same image as 4b union model
			header: t("cards.bria3_1_union.header"),
			description: t("cards.bria3_1_union.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["BRIA3_1_UNION"].HUGGING_FACE.MODEL)}
					>
						{t("cards.bria3_1_union.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["BRIA3_1_UNION"].HUGGING_FACE.DEMO)}
					>
						{t("cards.bria3_1_union.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: Auxiliary4BAdaptUnion,
			header: t("cards.4b_adapt_union.header"),
			description: t("cards.4b_adapt_union.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["4B_UNION"].HUGGING_FACE.MODEL)}
					>
						{t("cards.4b_adapt_union.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["4B_UNION"].HUGGING_FACE.DEMO)}
					>
						{t("cards.4b_adapt_union.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryRMBG,
			header: t("cards.rmgb_2_0.header"),
			description: t("cards.rmgb_2_0.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["REMOVE_BG"].HUGGING_FACE.MODEL)}
					>
						{t("cards.rmgb_2_0.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["REMOVE_BG"].HUGGING_FACE.DEMO)}
					>
						{t("cards.rmgb_2_0.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryFastLora,
			header: t("cards.2_3_fast_lora.header"),
			description: t("cards.2_3_fast_lora.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["2_3_FAST_LORA"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_fast_lora.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["2_3_FAST_LORA"].HUGGING_FACE.DEMO)}
					>
						{t("cards.2_3_fast_lora.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryImagePrompt,
			header: t("cards.2_3_prompt_adapter.header"),
			description: t("cards.2_3_prompt_adapter.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["IMAGE_PROMPT"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_prompt_adapter.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["IMAGE_PROMPT"].HUGGING_FACE.DEMO)}
					>
						{t("cards.2_3_prompt_adapter.secondaryBtn")}
					</BriaButton>
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryIDPreservation,
			header: t("cards.2_3_ip_adapter.header"),
			description: t("cards.2_3_ip_adapter.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["IP_ADAPTER"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_ip_adapter.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["IP_ADAPTER"].HUGGING_FACE.DEMO)}
					>
						{t("cards.2_3_ip_adapter.secondaryBtn")}
					</BriaButton>
					{/* <BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["IP_ADAPTER"].HUGGING_FACE.TUTORIAL)}
					>
						{t("cards.2_3_ip_adapter.thirdBtn")}
					</BriaButton> */}
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryGenFill,
			header: t("cards.2_3_genfill.header"),
			description: t("cards.2_3_genfill.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["GEN_FILL"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_genfill.primaryBtn")}
					</BriaButton>

					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["GEN_FILL"].HUGGING_FACE.DEMO)}
					>
						{t("cards.2_3_genfill.secondaryBtn")}
					</BriaButton>
					{/* <BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["GEN_FILL"].HUGGING_FACE.TUTORIAL)}
					>
						{t("cards.2_3_genfill.thirdBtn")}
					</BriaButton> */}
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryBGGen,
			header: t("cards.2_3_replace_bg.header"),
			description: t("cards.2_3_replace_bg.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["REPLACE_BG"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_replace_bg.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["REPLACE_BG"].HUGGING_FACE.DEMO)}
					>
						{t("cards.2_3_replace_bg.secondaryBtn")}
					</BriaButton>
					{/* <BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["GEN_FILL"].HUGGING_FACE.TUTORIAL)}
					>
						{t("cards.2_3_replace_bg.thirdBtn")}
					</BriaButton> */}
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryInpainting,
			header: t("cards.2_3_inpainting.header"),
			description: t("cards.2_3_inpainting.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["INPAINTING"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_inpainting.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["INPAINTING"].HUGGING_FACE.DEMO)}
					>
						{t("cards.2_3_inpainting.secondaryBtn")}
					</BriaButton>
					{/* <BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["GEN_FILL"].HUGGING_FACE.TUTORIAL)}
					>
						{t("cards.2_3_inpainting.thirdBtn")}
					</BriaButton> */}
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryCanny,
			header: t("cards.2_3_canny.header"),
			description: t("cards.2_3_canny.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["INPAINTING"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_canny.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["INPAINTING"].HUGGING_FACE.DEMO)}
					>
						{t("cards.2_3_canny.secondaryBtn")}
					</BriaButton>
					{/* <BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["GEN_FILL"].HUGGING_FACE.TUTORIAL)}
					>
						{t("cards.2_3_canny.thirdBtn")}
					</BriaButton> */}
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryDepth,
			header: t("cards.2_3_depth.header"),
			description: t("cards.2_3_depth.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["DEPTH"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_depth.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["INPAINTING"].HUGGING_FACE.DEMO)}
					>
						{t("cards.2_3_depth.secondaryBtn")}
					</BriaButton>
					{/* <BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["GEN_FILL"].HUGGING_FACE.TUTORIAL)}
					>
						{t("cards.2_3_depth.thirdBtn")}
					</BriaButton> */}
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryPose,
			header: t("cards.2_3_pose.header"),
			description: t("cards.2_3_pose.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["DEPTH"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_pose.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["DEPTH"].HUGGING_FACE.DEMO)}
					>
						{t("cards.2_3_pose.secondaryBtn")}
					</BriaButton>
					{/* <BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["GEN_FILL"].HUGGING_FACE.TUTORIAL)}
					>
						{t("cards.2_3_pose.thirdBtn")}
					</BriaButton> */}
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryRecoloring,
			header: t("cards.2_3_recoloring.header"),
			description: t("cards.2_3_recoloring.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["RECOLOR"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_recoloring.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["RECOLOR"].HUGGING_FACE.DOWNLOAD)}
					>
						{t("cards.2_3_recoloring.secondaryBtn")}
					</BriaButton>
					{/* <BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["GEN_FILL"].HUGGING_FACE.TUTORIAL)}
					>
						{t("cards.2_3_recoloring.thirdBtn")}
					</BriaButton> */}
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryColorGrid,
			header: t("cards.2_3_colorgrid.header"),
			description: t("cards.2_3_colorgrid.description"),
			buttons: (
				<BriaButtonGroup>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["COLORGRID"].HUGGING_FACE.MODEL)}
					>
						{t("cards.2_3_colorgrid.primaryBtn")}
					</BriaButton>
					<BriaButton
						buttonType="textSmall"
						startIcon={<HuggingFace />}
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["COLORGRID"].HUGGING_FACE.DEMO)}
					>
						{t("cards.2_3_colorgrid.secondaryBtn")}
					</BriaButton>
					{/* <BriaButton
						buttonType="textSmall"
						onClick={() => openDocs(LinkConstants.MODELS.AUXILIARY["GEN_FILL"].HUGGING_FACE.TUTORIAL)}
					>
						{t("cards.2_3_colorgrid.thirdBtn")}
					</BriaButton> */}
				</BriaButtonGroup>
			),
		},
		{
			image: AuxiliaryIncreaseRes,
			header: t("cards.increase_res.header"),
			description: t("cards.increase_res.description"),
		},
	];

	return (
		<ConsoleAPILayout description={t("description")} hideCopyTokenBtn>
			<ConsoleAPICards cards={cards} />
		</ConsoleAPILayout>
	);
};

export default observer(ModelsAuxiliary);
